import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ChannelListTipContainer = styled.div<React.CSSProperties>`
  position: relative;
  top: ${50 * Screen.widthRatio}px;
`;

export default ChannelListTipContainer;
